/* eslint-disable import/prefer-default-export */
export function formatMitarbeiterFullName(value) {
  return value?.full_name || '';
}
